var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBurgurDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_212_1640",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 6,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_212_1640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 22.6673C13.5413 22.6673 13.149 22.5041 12.8226 22.1777C12.4962 21.8513 12.333 21.459 12.333 21.0007C12.333 20.5423 12.4962 20.15 12.8226 19.8236C13.149 19.4972 13.5413 19.334 13.9997 19.334C14.458 19.334 14.8504 19.4972 15.1768 19.8236C15.5031 20.15 15.6663 20.5423 15.6663 21.0007C15.6663 21.459 15.5031 21.8513 15.1768 22.1777C14.8504 22.5041 14.458 22.6673 13.9997 22.6673ZM13.9997 17.6673C13.5413 17.6673 13.149 17.5041 12.8226 17.1777C12.4962 16.8513 12.333 16.459 12.333 16.0007C12.333 15.5423 12.4962 15.15 12.8226 14.8236C13.149 14.4972 13.5413 14.334 13.9997 14.334C14.458 14.334 14.8504 14.4972 15.1768 14.8236C15.5031 15.15 15.6663 15.5423 15.6663 16.0007C15.6663 16.459 15.5031 16.8513 15.1768 17.1777C14.8504 17.5041 14.458 17.6673 13.9997 17.6673ZM13.9997 12.6673C13.5413 12.6673 13.149 12.5041 12.8226 12.1777C12.4962 11.8513 12.333 11.459 12.333 11.0007C12.333 10.5423 12.4962 10.15 12.8226 9.82357C13.149 9.49718 13.5413 9.33398 13.9997 9.33398C14.458 9.33398 14.8504 9.49718 15.1768 9.82357C15.5031 10.15 15.6663 10.5423 15.6663 11.0007C15.6663 11.459 15.5031 11.8513 15.1768 12.1777C14.8504 12.5041 14.458 12.6673 13.9997 12.6673Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBurgurDot);
export default __webpack_public_path__ + "static/media/ic_burgur_dot.85000c028979f9dac9f3ba2617428ee2.svg";
export { ForwardRef as ReactComponent };